module.exports = __webpack_public_path__ + "img/img-5.628c5a5a.svg";